/** In-memory voice take. Never write to IDB, Cache Storage, SW, or a server. */
export interface MemoryTake {
  blob: Blob;
  createdAt: number;
}

export function createMemoryTakeStore(maxTakes = 3) {
  const takes: MemoryTake[] = [];
  const objectUrls: string[] = [];
  return {
    add(blob: Blob, makeUrl: (b: Blob) => string): string {
      while (takes.length >= maxTakes) {
        takes.shift();
        const old = objectUrls.shift();
        if (old) URL.revokeObjectURL(old);
      }
      takes.push({ blob, createdAt: Date.now() });
      const url = makeUrl(blob);
      objectUrls.push(url);
      return url;
    },
    clear(): void {
      takes.length = 0;
      while (objectUrls.length) {
        const url = objectUrls.shift();
        if (url) URL.revokeObjectURL(url);
      }
    },
    count(): number {
      return takes.length;
    },
    urls(): string[] {
      return [...objectUrls];
    },
  };
}

export const RECORDING_POLICY = {
  maxTakes: 3,
  maxSeconds: 10,
  upload: false,
  persist: false,
  serviceWorker: false,
  indexedDb: false,
} as const;
